{
  "success": true,
  "message": "Depósito notarial de cláusula de rescisión completado con éxito."
}
